<fui-rows [formGroup]="editService.formGroup">
    <fui-row>
        <fui-two-columns>
            <fui-column formGroupName="user">
                <ng-container formGroupName="accessRole">
                    <wbo-access-role-single-select-edit-control formControlName="accessRoleId"
                                                                [(ngModel)]="model.data.user.accessRole.accessRoleId"
                                                                [objectValue]="model.data.user.accessRole">
                    </wbo-access-role-single-select-edit-control>
                </ng-container>
            </fui-column>
            <fui-column formGroupName="position">
                <wbo-position-single-select-edit-control formControlName="positionId" [(ngModel)]="model.data.position.positionId"
                                                         [objectValue]="model.data.position">
                </wbo-position-single-select-edit-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row>
        <fui-two-columns>
            <fui-column>
                <wbo-single-select-edit-control formControlName="status" [(ngModel)]="model.data.status">
                    <wbo-select-options>
                        <wbo-select-option label="wbo.employee.edit.option.status.casual"></wbo-select-option>
                        <wbo-select-option label="wbo.employee.edit.option.status.partTime"></wbo-select-option>
                        <wbo-select-option label="wbo.employee.edit.option.status.permPartTime"></wbo-select-option>
                        <wbo-select-option label="wbo.employee.edit.option.status.fullTime"></wbo-select-option>
                        <wbo-select-option label="wbo.employee.edit.option.status.unemployed"></wbo-select-option>
                    </wbo-select-options>
                </wbo-single-select-edit-control>
            </fui-column>
            <fui-column>
                <wbo-numeric-edit-control formControlName="hourlyRate"
                                          [(ngModel)]="model.data.hourlyRate"></wbo-numeric-edit-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row>
        <fui-two-columns>
            <fui-column>
                <wbo-textarea-edit-control formControlName="comments"
                                           [(ngModel)]="model.data.comments"></wbo-textarea-edit-control>
            </fui-column>
            <fui-column>
                <wbo-date-edit-control formControlName="startDate"
                                       [(ngModel)]="model.data.startDate"></wbo-date-edit-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>
</fui-rows>
